import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue';
import { tabsProps, tabsEmits } from './tabs';
import { UPDATE_MODEL_VALUE } from '../../constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'tabs',
  props: tabsProps,
  emits: tabsEmits,
  setup(__props, { emit: emits }) {

const props = __props




const sliderStyle = ref<string>('');
const tabsContainer = ref<HTMLElement | null>(null);
const buttonRefs = ref<any[]>([]);

const updateSlider = (): void => {
    const index = props.tabs.findIndex((tab) => tab.value === props.modelValue);
    if (index === -1) return;

    const btn = buttonRefs.value[index];
    const container = tabsContainer.value;
    if (!btn || !container) return;

    const containerRect = container.getBoundingClientRect();
    const btnRect = btn.getBoundingClientRect();
    const left = btnRect.left - containerRect.left - container.clientLeft;
    sliderStyle.value = `left: ${left}px; width: ${btnRect.width}px`;
};

const selectTab = (value: string): void => {
    emits(UPDATE_MODEL_VALUE, value);
};

onMounted(() => {
    updateSlider();
});

watch(() => props.modelValue, () => updateSlider(), { immediate: true });

return { __sfc: true,props, emits, sliderStyle, tabsContainer, buttonRefs, updateSlider, selectTab }
}

})